import React from "react";
import "./Our_solutions.css";

import { SolarPowers } from "../../../utils/apis/homepage/index";
import { useContext, useEffect, useState } from "react";
import { Context } from "../../../utils/context";
import { IDS } from "../../../utils/common";
import Common_heading from "../../common/common_heading/Common_heading";

const Our_solutions = () => {



  var HtmlToReactParser = require("html-to-react").Parser;
  var htmlToReactParser = new HtmlToReactParser();


  const { IMG_URL } = useContext(Context);
  
    const [solarpower, setSolarPower] = useState([]);
  
    const getSolarPowers = async () => {
      const res = await SolarPowers();
      if (res?.success) {
        setSolarPower(res.data);
      }
    };
    useEffect(() => {
      getSolarPowers();
    }, []);


  return (
    <section className="Our_solutions">
      <div className="custom_container">
      

         <Common_heading heading={"OUR SOLUTION"} subHeading={"CONSISTENT RELIABILITY FOR ANY INDUSTRY, ANY CHALLENGE."}/>

        <div className="solar_card_div">
          <div className="row  me-0 ms-0 justify-content-center">
            {solarpower.map((item, index) => (
              <div
                className="col-xl-3 col-lg-4 col-md-4 col-sm-6 col-12 mb-5 mt-3"
                key={index}
              >
                <div className="solar_box">
                
                  <div className="solar_img_div">
                    <img
                      src={IDS?.IMG_URL + item?.image}
                      alt={item.title}
                      className="solar_img"
                    />
                  </div>
                    <div className="solar_content">
                    <h5 className="card_title">{item.name}</h5>
                    {/* <p className="card_span">{item.subtitle}</p> */}
                    {/* <p className="card_text">{htmlToReactParser.parse(item.description)}</p> */}
                  </div>

                  {/* <div className="card_btn_holder">
                    <button className="card_btn">View Details</button>{" "}
                  </div> */}
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default Our_solutions;
